import Vue from 'vue';
import PortalVue from 'portal-vue';
import Fragment from 'vue-fragment';
import VueCookies from 'vue-cookies';
import NProgress from 'nprogress';
import 'vue-search-select/dist/VueSearchSelect.css';
import { v4 as uuidV4 } from 'uuid';

import '@/libs/validation';
import '@/libs/api';

import App from './App.vue';
import router from './router';
import store from './store';
import auth from './libs/auth';
import hasPermission from './libs/permission';
import sidebar from './configs/sidebar';

Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.use(Fragment.Plugin);
Vue.use(VueCookies);

NProgress.configure({
  showSpinner: false,
});

let progressBarTimeout: number | undefined;

type Permission = string | string[];

interface Sidebar {
  children: Sidebar[];
  permission: Permission;
  to: string;
  environment: string | string[];
  isInternal: number | undefined;
}

function loop(array: Sidebar[], permission: undefined | Permission, res: any) {
  array.forEach((v: Sidebar) => {
    if ('children' in v) {
      loop(v.children, 'permission' in v ? v.permission : permission, res);
    }

    res.push({
      to: v.to,
      permission: 'permission' in v ? v.permission : permission,
      isInternal: v.isInternal,
      environment: v.environment,
    });
  });
}

router.beforeEach(async (to, from, next) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || process.env.VUE_APP_TITLE;
  });
  clearTimeout(progressBarTimeout);
  progressBarTimeout = window.setTimeout(NProgress.start, 200);

  const rt = new URLSearchParams(window.location.search);
  if (rt.get('rt') !== null) {
    let uuid = Vue.$cookies.get('browser_uuid');
    if (!uuid) {
      console.log('empty uuid');
      uuid = uuidV4();
      Vue.$cookies.set('browser_uuid', uuid, '100y', '/', window.location.hostname);
    }
    console.log('uuid', uuid);

    Vue.$cookies.set('refresh_token', rt.get('rt'), '1d', '/', window.location.hostname);
    Vue.$cookies.set('reference_token', rt.get('reference'), '1d', '/', window.location.hostname);
    rt.delete('rt');
    rt.delete('reference');
    window.history.pushState({}, '', `${window.location.pathname}?${rt.toString()}`);
    window.location.reload();
    localStorage.removeItem('last-destroy');
    return;
  }

  if (to.matched.some((record) => !record.meta.ignoreAuth)) {
    if (!store.state.loggedIn) {
      const result = await auth.checkToken();
      if (!result) {
        next({
          path: '/login',
          query: { redirect: to.fullPath },
        });
      } else {
        let havePermission = false;
        const sdbr: any = [];
        loop(sidebar as any, undefined, sdbr);
        const p = sdbr.filter((e: Sidebar) => e.to === to.path);
        if (p.length > 0) {
          p.forEach((pchild: any) => {
            const { permission, environment, isInternal } = pchild;
            const hp = hasPermission(permission, environment, isInternal);
            if (hp) {
              havePermission = true;
            }
          });
        } else {
          const splitPath = to.path.split('/');
          let breaks = false;
          for (let i = splitPath.length - 1; i >= 2; i -= 1) {
            splitPath.pop();
            const p1 = sdbr.filter((e: Sidebar) => e.to === splitPath.join('/'));
            if (p1.length > 0) {
              for (let j = 0; j < p1.length; j += 1) {
                const { permission, environment, isInternal } = p1[j];
                const hp1 = hasPermission(permission, environment, isInternal);
                if (hp1) {
                  breaks = true;
                  break;
                }
              }
              if (breaks) {
                havePermission = true;
                break;
              }
            }
          }
        }
        if (havePermission) {
          next();
        } else {
          next({
            path: '/dashboard',
          });
        }
      }
    } else {
      let havePermission = false;
      const sdbr: any = [];
      loop(sidebar as any, undefined, sdbr);
      const p = sdbr.filter((e: Sidebar) => e.to === to.path);
      if (p.length > 0) {
        p.forEach((pchild: any) => {
          const { permission, environment, isInternal } = pchild;
          const hp = hasPermission(permission, environment, isInternal);
          if (hp) {
            havePermission = true;
          }
        });
      } else {
        const splitPath = to.path.split('/');
        let breaks = false;
        for (let i = splitPath.length - 1; i >= 2; i -= 1) {
          splitPath.pop();
          const p1 = sdbr.filter((e: Sidebar) => e.to === splitPath.join('/'));
          if (p1.length > 0) {
            for (let j = 0; j < p1.length; j += 1) {
              const { permission, environment, isInternal } = p1[j];
              const hp1 = hasPermission(permission, environment, isInternal);
              if (hp1) {
                breaks = true;
                break;
              }
            }
            if (breaks) {
              havePermission = true;
              break;
            }
          }
        }
      }
      if (havePermission) {
        next();
      } else {
        next({
          path: '/dashboard',
        });
      }
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  clearTimeout(progressBarTimeout);
  NProgress.done();
});

router.onReady(() => {
  console.log('readyy');
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
